export default __webpack_public_path__ + "static/media/3.c4199e4c.jpg";